const tpaSettingsFrameSelector = '#tpaSettingsFrame';

const getNodeOffset = (node: Element) => {
  const { left, top, width, height } = node.getBoundingClientRect();

  return {
    left: left + window.scrollX,
    top: top + window.scrollY,
    width: Math.round(width),
    height: Math.round(height),
  };
};

export const getTpaSettingsPositionRelativeToEditor =
  (positionInSettingsIframe: { top: number; left: number }) => {
    const iframeNode = document.querySelector(tpaSettingsFrameSelector);
    const iframePos = iframeNode ? getNodeOffset(iframeNode) : null;

    if (iframePos) {
      return {
        x: (positionInSettingsIframe.left || 0) + (iframePos.left || 0),
        y: (positionInSettingsIframe.top || 0) + (iframePos.top || 0),
      };
    }

    return {
      x: positionInSettingsIframe.left,
      y: positionInSettingsIframe.top,
    };
  };
